import { authenticateWithProvider } from './ProviderAuth.js'

export const authenticateWithGoogle = options => authenticateWithProvider({
  ...options,
  providerName: 'Google',
  createProvider: () => {
    const provider = new options.firebase.auth.GoogleAuthProvider()
    provider.setCustomParameters({ prompt: 'select_account' })
    return provider
  }
})
